import React from 'react';
import cx from 'classnames';
import { OutlineButton } from '../../../Button';
import { ReactStars } from '../../../RatingViewer/ReactStars';
import styles from '../style.module.css';

interface Props {
  rate: string;
  ratings?: any[];
  alignStart?: boolean;
  className?: string;
  handleToggleModalComment: () => void;
  handleToggleRatingModal: () => void;
  total: string;
}

export const ShopRatings = ({
  rate,
  total,
  alignStart,
  className = '',
  handleToggleModalComment,
  handleToggleRatingModal,
}: Props) => {
  const reactStarsProps = {
    value: parseFloat(rate),
    size: 24,
    onChange: () => null,
    edit: false,
    className: styles.stars,
  };

  if (!rate && !total) {
    return null;
  }

  const newRate = parseFloat(rate);

  const outlineButtonProps = {
    onClick: handleToggleModalComment,
    resetPadding: true,
    className: cx('pa12 pa8-ns pa14-m pa14-l', styles.w130h48),
    heightAuto: true,
  };

  const containerActionsClasses = cx('flex items-center', styles.showRatings, {
    'justify-center': !alignStart,
    'justify-start': alignStart,
  });

  return (
    <div className={className}>
      <div className={`relative ${styles.boxRates}`}>
        <span className={`absolute f16 abbey trueno fw3 ${styles.rate}`}>{newRate.toFixed(1)}</span>
        <ReactStars {...reactStarsProps} />
        <span className={`absolute f16 abbey trueno fw3 ${styles.ratings}`}>({total})</span>
      </div>
      <div className={containerActionsClasses}>
        <span
          onClick={handleToggleRatingModal}
          className={'dib red-two trueno fw5 f14 f14-ns f14-m f16-l underline pointer mr12'}
        >
          Ver avaliações
        </span>
        <div className="dib">
          <OutlineButton {...outlineButtonProps}>
            <p className="f12-ns f12 f16-l trueno fw6 m0">AVALIAR</p>
          </OutlineButton>
        </div>
      </div>
    </div>
  );
};
